import { fetchKpi, createKpi, updateKpi, fetchKpiUnits, fetchKpiDataTypes, fetchAssignedKpi, enableKpi, disableKpi, fetchKpiActivities } from "@features/admin/kpi/api/kpiApi";
import { KpiResponse } from "@features/admin/kpi/types/kpi";
import ApiResponse from "@core/types/apiResponse";
import { KpiUnitResponse } from "@features/admin/kpi/types/kpiUnits";
import { KpiDataTypeResponse } from "@features/admin/kpi/types/kpiDataTypes";
import { CreateKpiRequest, UpdateKpiRequest } from "../types/kpiRequests";

export const fetchKpiAsync = async (nationId: number, params: any): Promise<ApiResponse<KpiResponse>> => {
    const { nationId: _removedNationId, ...filteredParams } = params || {};
    const response = await fetchKpi(nationId, filteredParams);
    return response;
};

export const fetchAssignedKpiAsync = async (nationId: number, activityId: number, params: any): Promise<ApiResponse<KpiResponse>> => {
    const response = await fetchAssignedKpi(nationId, activityId, params);
    return response;
};

export const fetchKpiActivitiesAsync = async (
    nationId: number,
    kpiId: number
): Promise<Array<{ activity_id: number; activity_name: string }>> => {
    const response = await fetchKpiActivities(nationId, kpiId);
    return response.data?.data ?? [];
};

export const fetchKpiUnitsAsync = async (nationId: number, params: any): Promise<ApiResponse<KpiUnitResponse>> => {
    const response = await fetchKpiUnits(nationId, params);
    return response;
};

export const fetchKpiDataTypesAsync = async (nationId: number, params: any): Promise<ApiResponse<KpiDataTypeResponse>> => {
    const response = await fetchKpiDataTypes(nationId, params);
    return response;
};

export const createKpiAsync = async (nationId: number, data: CreateKpiRequest): Promise<ApiResponse<any>> => {
    const response = await createKpi(nationId, data);
    return response;
};

export const updateKpiAsync = async (nationId: number, kpiId: number, data: UpdateKpiRequest): Promise<ApiResponse<any>> => {
    const response = await updateKpi(nationId, kpiId, data);
    return response;
};

export const disableKpiAsync = async (
    nationId: number,
    kpiId: number
): Promise<ApiResponse<any>> => {
    return disableKpi(nationId, kpiId);
};

export const enableKpiAsync = async (nationId: number, kpiId: number): Promise<ApiResponse<any>> => {
    return enableKpi(nationId, kpiId);
};
